import { Titulo, Page } from '@/models';
import { AxiosRequestConfig } from 'axios';
import { Inject } from 'inversify-props';
import { TituloServiceAdapter } from '../titulos/adapter/TituloServiceAdapter';

export class FindTituloUseCase {
	@Inject("TituloServiceAdapter")
	private tituloServiceAdapter!: TituloServiceAdapter

	findAll = async (params?: any): Promise <Titulo[]> =>
		(await this.tituloServiceAdapter.find(params)).content

	findById = async (id: string): Promise<Titulo> =>
		await this.tituloServiceAdapter.get(id)
	
	find = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Titulo>> =>
		await this.tituloServiceAdapter.find(params, config)
}